import React from 'react'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectRestaurant } from '~/redux/restaurantSlice'

// Component dùng chung ở nhiều màn. Hiển thị Order code
const OrderCode = () => {
  const { order_code } = useSelector(selectRestaurant)

  return (
    <Box
      display="inline-flex"
      fontSize="4rem"
      fontWeight="700"
      px="30px"
      pt="10px"
      pb="4px"
      bgcolor="baseColor.color5"
      color="baseColor.colorText3"
      borderRadius="999px">
      {order_code}
    </Box>
  )
}

export default React.memo(OrderCode)
